import { cloneDeep } from 'lodash';
import { FilterOptions, TableDataRow } from 'src/store/adminConfigPageSlice/siteConfigPageSlice/types';
import { createTags, filterByBooleans, filterByStrings } from 'src/utils/tableUtils';

class SiteFilterService {
  public filterSites(tableData: TableDataRow[], filters: FilterOptions) {
    let filteredData = cloneDeep(tableData);
    filteredData = filterByStrings(filteredData, 'site', filters.sites);
    filteredData = filterByStrings(filteredData, 'country', filters.countries);
    filteredData = filterByStrings(filteredData, 'org', filters.orgs);
    filteredData = filterByStrings(filteredData, 'subOrg', filters.subOrgs);
    filteredData = filterByStrings(filteredData, 'region', filters.regions);
    filteredData = filterByStrings(filteredData, 'buildingType', filters.buildingTypes);
    filteredData = filterByBooleans(
      filteredData,
      'isActive',
      filters.isActive.map((isActive) => isActive === 'Yes'),
    );

    return filteredData;
  }

  public getFilterTags(filters: FilterOptions) {
    const tags = [
      ...createTags(filters, 'sites', 'Site'),
      ...createTags(filters, 'countries', 'Country'),
      ...createTags(filters, 'regions', 'Region'),
      ...createTags(filters, 'orgs', 'Org'),
      ...createTags(filters, 'subOrgs', 'Sub Org'),
      ...createTags(filters, 'buildingTypes', 'Building Type'),
      ...createTags(filters, 'isActive', 'Is Active'),
    ];
    return tags;
  }
}

export default new SiteFilterService();
